export class RequirementStatus{
    requirementStatusID:number;
    requirementStatusName:string;
}

export class DashBoardFilterModel {
    UserId: string;
    RoleId: string;
    ReqType: string;
    SBUCode: string;
    DivisionCode: string;
    ZoneCode: string;
    RegionCode: string;
    RMHCode: string;
    Product: string;
    Month: string;
    Status: string;
    WhLocation: string;
    Quarter:string;
    Year:string;
    Crop:string;
}
export class DashBoardDetails {
    RequestNo: number;
    Region: string;
    ReqType: string;
    RMHName: string;
    Product: string;
    Crop: string;
    Month: string;
    WHLocation: string;
    FinalApprovedQty: number;
    DispatchedQTYtoSDWH: number;
    DispatchedQTYToFieldTeam: number;
    Status: string;
   
}
